var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreensizeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17781_1828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17781_1828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.77788 14.8214C2.77788 15.4649 3.29761 15.9846 3.94107 15.9846L8.01636 15.9846L8.01636 20.0599C8.01636 20.7034 8.53609 21.2231 9.17956 21.2231C9.82302 21.2231 10.3427 20.7034 10.3427 20.0599L10.3427 14.8297C10.3427 14.1862 9.82302 13.6665 9.17955 13.6665L3.94932 13.6665C3.30585 13.65 2.77788 14.178 2.77788 14.8214V14.8214ZM21.2239 9.17871C21.2239 8.53524 20.7042 8.01552 20.0607 8.01552L15.9855 8.01552L15.9855 3.94022C15.9855 3.29676 15.4657 2.77703 14.8223 2.77703C14.1788 2.77703 13.6508 3.30501 13.6508 3.94847L13.6508 9.17871C13.6508 9.82217 14.1705 10.3419 14.814 10.3419L20.0442 10.3419C20.696 10.3501 21.2239 9.82217 21.2239 9.17871V9.17871Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17781_1828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17781_1828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(12 -7.79883) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensizeSmall);
export default __webpack_public_path__ + "static/media/screensize-small.8e1b929a810391a5449c0ec86e52f008.svg";
export { ForwardRef as ReactComponent };